import { StepResultDc } from "@evergis/api";

export function collectErrorLog(stepResults: StepResultDc[]): string {
  const errorMessages = stepResults.map(step => step.batchErrors).filter(value => Array.isArray(value));

  return errorMessages.flat().join("\n");
}
